/* This file is based on `vscode-lean4/vscode-lean4/src/abbreviation/rewriter/AbbreviationRewriter.ts` */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { assert } from 'lean4/src/utils/assert';
import { config } from '../config';
import { Range } from 'lean4/src/abbreviation/rewriter/Range';
import { TrackedAbbreviation } from './TrackedAbbreviation';
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api.js';
import { Range as MonacoRange } from 'monaco-editor';
import { AbbreviationHoverProvider } from '../AbbreviationHoverProvider';
/**
 * Tracks abbreviations in a given text editor and replaces them when dynamically.
 */
var AbbreviationRewriter = /** @class */ (function () {
    // private stderrOutput: OutputChannel;
    // private firstOutput = true;
    function AbbreviationRewriter(abbreviationProvider, model, editor) {
        var _this = this;
        this.abbreviationProvider = abbreviationProvider;
        this.model = model;
        this.editor = editor;
        this.disposables = new Array();
        // /**
        //  * All tracked abbreviations are disjoint.
        //  */
        this.trackedAbbreviations = new Set();
        // private readonly decorationType = window.createTextEditorDecorationType({
        // 	textDecoration: 'underline',
        // });
        this.dontTrackNewAbbr = false;
        this.decosIds = [];
        this.disposables.push(model.onDidChangeContent(function (e) {
            var e_1, _a;
            var changes = e.changes.slice(0);
            // // We need to process the changes at the bottom first.
            // // Otherwise, changes at the top will move spans at the bottom down.
            changes.sort(function (c1, c2) { return c2.rangeOffset - c1.rangeOffset; });
            try {
                for (var changes_1 = __values(changes), changes_1_1 = changes_1.next(); !changes_1_1.done; changes_1_1 = changes_1.next()) {
                    var c = changes_1_1.value;
                    var range = new Range(c.rangeOffset, c.rangeLength);
                    _this.processChange(range, c.text);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (changes_1_1 && !changes_1_1.done && (_a = changes_1.return)) _a.call(changes_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            _this.updateState();
            // // Replace any tracked abbreviation that is either finished or unique.
            void _this.forceReplace(__spreadArray([], __read(_this.trackedAbbreviations), false).filter(function (abbr) {
                return abbr.finished ||
                    (config.eagerReplacementEnabled &&
                        abbr.isAbbreviationUniqueAndComplete);
            }));
        }));
        this.disposables.push(editor.onDidChangeCursorSelection(function (e) {
            // Replace any tracked abbreviation that lost selection.
            void _this.forceReplace(__spreadArray([], __read(_this.trackedAbbreviations), false).filter(function (abbr) {
                return !__spreadArray(__spreadArray([], __read(e.secondarySelections), false), [e.selection], false).some(function (s) {
                    return abbr.range.containsRange(fromVsCodeRange(s, _this.model).withLength(0));
                });
            }));
        }));
        // this.isActiveContextKey = this.editor.createContextKey('lean4.input.isActive', false);
        this.disposables.push(monaco.editor.addEditorAction({
            id: 'lean4.input.convert',
            label: 'Convert abbreviation',
            precondition: "editorTextFocus && editorLangId == lean4 && lean4.input.isActive",
            keybindings: [monaco.KeyCode.Tab],
            run: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, this.forceReplace(__spreadArray([], __read(this.trackedAbbreviations), false))];
            }); }); }
        }));
        this.abbreviationHoverProvider = new AbbreviationHoverProvider(this.abbreviationProvider);
        this.disposables.push(monaco.languages.registerHoverProvider('lean4', this.abbreviationHoverProvider));
    }
    AbbreviationRewriter.prototype.forceReplace = function (abbreviations) {
        return __awaiter(this, void 0, void 0, function () {
            var abbreviations_1, abbreviations_1_1, a, cursorVar, replacements, _loop_1, abbreviations_2, abbreviations_2_1, abbr, newSelections, ok, e_2;
            var e_3, _a, e_4, _b;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (abbreviations.length === 0) {
                            return [2 /*return*/];
                        }
                        try {
                            for (abbreviations_1 = __values(abbreviations), abbreviations_1_1 = abbreviations_1.next(); !abbreviations_1_1.done; abbreviations_1_1 = abbreviations_1.next()) {
                                a = abbreviations_1_1.value;
                                this.trackedAbbreviations.delete(a);
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (abbreviations_1_1 && !abbreviations_1_1.done && (_a = abbreviations_1.return)) _a.call(abbreviations_1);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                        // Wait for VS Code to trigger `onDidChangeTextEditorSelection`
                        return [4 /*yield*/, waitForNextTick()];
                    case 1:
                        // Wait for VS Code to trigger `onDidChangeTextEditorSelection`
                        _c.sent();
                        cursorVar = '$CURSOR';
                        replacements = new Array();
                        _loop_1 = function (abbr) {
                            var symbol = abbr.matchingSymbol;
                            if (symbol) {
                                var newText = symbol.replace(cursorVar, '');
                                var cursorOffset_1 = symbol.indexOf(cursorVar);
                                if (cursorOffset_1 === -1) {
                                    // position the cursor after the inserted symbol
                                    cursorOffset_1 = newText.length;
                                }
                                replacements.push({
                                    range: abbr.range,
                                    newText: newText,
                                    transformOffsetInRange: function (offset) { return cursorOffset_1; },
                                });
                            }
                        };
                        try {
                            for (abbreviations_2 = __values(abbreviations), abbreviations_2_1 = abbreviations_2.next(); !abbreviations_2_1.done; abbreviations_2_1 = abbreviations_2.next()) {
                                abbr = abbreviations_2_1.value;
                                _loop_1(abbr);
                            }
                        }
                        catch (e_4_1) { e_4 = { error: e_4_1 }; }
                        finally {
                            try {
                                if (abbreviations_2_1 && !abbreviations_2_1.done && (_b = abbreviations_2.return)) _b.call(abbreviations_2);
                            }
                            finally { if (e_4) throw e_4.error; }
                        }
                        // Process replacements with highest offset first
                        replacements.sort(function (a, b) { return b.range.offset - a.range.offset; });
                        newSelections = this.editor.getSelections()
                            .map(function (s) { return ({ range: fromVsCodeRange(s, _this.model), dir: s.getDirection() }); })
                            .map(function (_a) {
                            var e_5, _b;
                            var s = _a.range, dir = _a.dir;
                            // Apply the replacement of abbreviations to the selections.
                            var newSel = s;
                            try {
                                for (var replacements_1 = __values(replacements), replacements_1_1 = replacements_1.next(); !replacements_1_1.done; replacements_1_1 = replacements_1.next()) {
                                    var r = replacements_1_1.value;
                                    if (r.range.isBefore(newSel) &&
                                        !r.range.containsRange(newSel)) {
                                        // don't do this on ` \abbr| `
                                        newSel = newSel.move(r.newText.length - r.range.length);
                                    }
                                    else if (!r.range.isAfter(newSel) ||
                                        r.range.containsRange(newSel)) {
                                        // do this on ` \abbr| ` or ` \ab|br `
                                        // newSel and r.range intersect
                                        var offset = newSel.offset - r.range.offset;
                                        var newOffset = r.transformOffsetInRange(offset);
                                        newSel = newSel.move(newOffset - offset);
                                    }
                                }
                            }
                            catch (e_5_1) { e_5 = { error: e_5_1 }; }
                            finally {
                                try {
                                    if (replacements_1_1 && !replacements_1_1.done && (_b = replacements_1.return)) _b.call(replacements_1);
                                }
                                finally { if (e_5) throw e_5.error; }
                            }
                            return { range: newSel, dir: dir };
                        });
                        // We don't want replaced symbols (e.g. "\") to trigger abbreviations.
                        this.dontTrackNewAbbr = true;
                        ok = false;
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 5, , 6]);
                        return [4 /*yield*/, this.editor.pushUndoStop()];
                    case 3:
                        _c.sent();
                        return [4 /*yield*/, this.editor.executeEdits("abbreviation-rewriter", replacements.map(function (r) {
                                return {
                                    range: toVsCodeRange(r.range, _this.model),
                                    text: r.newText
                                };
                            }))];
                    case 4:
                        _c.sent();
                        ok = true;
                        return [3 /*break*/, 6];
                    case 5:
                        e_2 = _c.sent();
                        throw Error('Error: while replacing abbreviation: ' + e_2);
                    case 6:
                        this.dontTrackNewAbbr = false;
                        if (ok) {
                            this.editor.setSelections(newSelections.map(function (_a) {
                                var s = _a.range, dir = _a.dir;
                                var vr = toVsCodeRange(s, _this.model);
                                return monaco.Selection.fromRange(vr, dir);
                            }));
                            // this.abbreviationProvider.onAbbreviationsCompleted(this.textEditor);
                        }
                        else {
                            // Our edit did not succeed, do not update the selections.
                            // This can happen if `waitForNextTick` waits too long.
                            throw Error('Error: Unable to replace abbreviation');
                        }
                        this.updateState();
                        return [2 /*return*/];
                }
            });
        });
    };
    AbbreviationRewriter.prototype.updateState = function () {
        var _this = this;
        this.decosIds = this.model.deltaDecorations(this.decosIds, __spreadArray([], __read(this.trackedAbbreviations), false).map(function (a) {
            return {
                range: toVsCodeRange(a.range, _this.model),
                options: {
                    inlineClassName: 'abbreviation'
                }
            };
        }));
        // void this.setInputActive(this.trackedAbbreviations.size > 0);
    };
    // private async setInputActive(isActive: boolean) {
    // 	this.isActiveContextKey.set(isActive);
    // }
    AbbreviationRewriter.prototype.processChange = function (range, text) {
        var e_6, _a;
        var affectedAbbr;
        try {
            for (var _b = __values(__spreadArray([], __read(this.trackedAbbreviations), false)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var abbr = _c.value;
                var _d = abbr.processChange(range, text), isAffected = _d.isAffected, shouldStopTracking = _d.shouldStopTracking;
                if (isAffected) {
                    // At most one abbreviation should be affected
                    assert(function () { return !affectedAbbr; });
                    affectedAbbr = abbr;
                }
                if (shouldStopTracking) {
                    this.trackedAbbreviations.delete(abbr);
                }
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_6) throw e_6.error; }
        }
        if (text === config.abbreviationCharacter &&
            !affectedAbbr &&
            !this.dontTrackNewAbbr) {
            var abbr = new TrackedAbbreviation(new Range(range.offset + 1, 0), '', this.abbreviationProvider);
            this.trackedAbbreviations.add(abbr);
        }
        return { affectedAbbr: affectedAbbr };
    };
    AbbreviationRewriter.prototype.dispose = function () {
        var e_7, _a;
        try {
            for (var _b = __values(this.disposables), _c = _b.next(); !_c.done; _c = _b.next()) {
                var d = _c.value;
                d.dispose();
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_7) throw e_7.error; }
        }
    };
    return AbbreviationRewriter;
}());
export { AbbreviationRewriter };
function fromVsCodeRange(range, model) {
    var start = model.getOffsetAt(MonacoRange.getStartPosition(range));
    var end = model.getOffsetAt(MonacoRange.getEndPosition(range));
    return new Range(start, end - start);
}
function toVsCodeRange(range, model) {
    var start = model.getPositionAt(range.offset);
    var end = model.getPositionAt(range.offsetEnd + 1);
    return MonacoRange.fromPositions(start, end);
}
function waitForNextTick() {
    return new Promise(function (res) { return setTimeout(res, 0); });
}
